export const ADD_RECORD_TIME = 'ADD_RECORD_TIME';
export const SET_RECORD_TIME = 'SET_RECORD_TIME';
export const ADD_GENERALISED_ANXIETY_DISORDER = 'ADD_GENERALISED_ANXIETY_DISORDER';
export const SET_GENERALISED_ANXIETY_DISORDER = 'SET_GENERALISED_ANXIETY_DISORDER';
